module.exports = __webpack_public_path__ + "img/img2.e7a4b45b.svg";